import { createI18n } from "@wix/communities-blog-client-common";
import { initI18n as yoshiInitI18n} from "@wix/yoshi-flow-editor";

export const initI18n = (locale, translations) => {
  return createI18n(locale, translations, yoshiInitI18n);
};
